import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import StoreForm from './components/storeForm';
import Loading from 'components/Loading';
import { createStore, navigate, clearValidationErrors,
 requestDivisionList, requestRegionList, requestMarketList,
 requestPricePatchesList } from 'actionCreators';
import { getWorkroomList, getMarketList, getDivisionList,
  getRegionList, getStoreErrors, getPricePatchesList } from '../../../../reducers';
import ui from 'redux-ui';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';
import { filterByDivisionId, filterByRegionId } from '../../../../utils';

class StoreNew extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleDivisionChange = this.handleDivisionChange.bind(this);
    this.handleRegionChange = this.handleRegionChange.bind(this);

    this.handleCancel = () => { this.props.dispatch(navigate('/stores')); };
    this.setSucessMessage = (name, number) => {
      this.props.updateUI('successMessage',
      `The store # ${number} - ${name} was successfully created.`);
    };

    this.state = {
      regionId: null,
      divisionId: null,
      allLoaded: false,
    };
  }
  componentDidMount() {
    Promise.all([
      this.props.dispatch(requestDivisionList()),
      this.props.dispatch(requestPricePatchesList()),
    ]).then(() => {
      this.setState({ allLoaded: true });
    });
  }

  componentWillUnmount() {
    this.props.dispatch(clearValidationErrors('STORE'));
  }


  handleDivisionChange(divisionId) {
    const { dispatch } = this.props;
    dispatch(requestRegionList(divisionId));

    this.setState({
      divisionId,
      regionId: null,
    });
  }

  handleRegionChange(regionId) {
    const { dispatch } = this.props;

    this.setState({ regionId });
    dispatch(requestMarketList(regionId));
  }

  handleSave(store) {
    const { dispatch } = this.props;
    dispatch(createStore(store, this.setSucessMessage));
  }

  render() {
    const { errors, workrooms, markets, regions, divisions, pricePatches } = this.props;
    const { divisionId, regionId } = this.state;
    const filteredRegions = regions.filter(filterByDivisionId(divisionId));
    const filteredMarkets = markets.filter(filterByRegionId(regionId));

    return (
      <MediaQuery minWidth={CUT_POINT}>
        {
          this.state.allLoaded ? (
            <StoreForm
              errors={errors}
              onSave={this.handleSave}
              onCancel={this.handleCancel}
              onDivisionChange={this.handleDivisionChange}
              onRegionChange={this.handleRegionChange}
              workrooms={workrooms}
              markets={filteredMarkets}
              regions={filteredRegions}
              divisions={divisions}
              pricePatches={pricePatches}
            />
          )
          : <Loading />
        }

      </MediaQuery>
    );
  }
}

StoreNew.propTypes = {
  dispatch: PropTypes.func,
  errors: PropTypes.object,
  workrooms: PropTypes.array,
  markets: PropTypes.array,
  regions: PropTypes.array,
  divisions: PropTypes.array,
  updateUI: PropTypes.func,
  pricePatches: PropTypes.array,
};

const mapStateToProps = state => (
  {
    errors: getStoreErrors(state) || {},
    workrooms: getWorkroomList(state) || [],
    markets: getMarketList(state),
    regions: getRegionList(state),
    divisions: getDivisionList(state),
    pricePatches: getPricePatchesList(state),
  }
);

export default ui()(connect(
  mapStateToProps,
)(StoreNew));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/storeNew.jsx